import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { Patient } from '../patient/patient';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  
  private patientsUrl = '/api/patients';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  getPatients(): Observable<Patient[]> {
    return this.http
      .get<Patient[]>(this.patientsUrl)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getPatient(id: number): Observable<Patient> {
    return this.http
      .get<Patient>(`${this.patientsUrl}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  searchPatient(term: string): Observable<Patient[]> {
    if (!term.trim()) { return of([]); }
    return this.http
      .get<Patient[]>(`${this.patientsUrl}/?name=${term}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  createPatient(patient: Patient): Observable<Patient> {
    return this.http
      .post<Patient>(this.patientsUrl, patient, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  updatePatient(patient: Patient): Observable<Patient> {
    return this.http
      .patch<Patient>(`${this.patientsUrl}/${patient.id}`, patient, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
